var render = function render(){var _vm=this,_c=_vm._self._c;return _c('material-icon-button',{attrs:{"type":_vm.type,"show-icon":_vm.showIcon,"icon":_vm.icon,"classes":_vm.classes,"icons-outlined":_vm.iconsOutlined,"label":_vm.label,"submitting":_vm.submitting,"submitting-label":_vm.submittingLabel,"aria-live":"polite"},on:{"click-action":_vm.openConfirmModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }